import fr from 'facet-rest';

export const TrustApprovalOverride = fr.metaOverride()
  .nameOverride('trustName', { hidden: false, readonly: false })
  .nameOverride('dateOfTrustCreation', { hidden: false, readonly: false })
  .nameOverride('trustSitusState', { hidden: false, readonly: false })
  .hideNonRequiredFields();

export const TrusteeApprovalOverride = fr.metaOverride()
  .nameOverride('trustName', { hidden: false, readonly: false })
  .nameOverride('dateOfTrustCreation', { hidden: false, readonly: false })
  .nameOverride('trustSitusState', { hidden: false, readonly: false })
  .hideNonRequiredFields();
